import { useEffect, useState } from "react"
import { Input, Button, Form, Radio, Checkbox, Row, Col, Popconfirm, Modal, message } from 'antd'
import { useForm } from "antd/lib/form/Form"
import { AppstoreOutlined, EditOutlined, UpOutlined, ApartmentOutlined, DownOutlined, FileAddOutlined, DeleteOutlined } from '@ant-design/icons'
import { baseAxiosComplete, baseAxiosNoInfo } from "../../tool/axios"
import BreadCrumb from '../../component/BreadCrumb'
import _ from 'lodash'

const CheckboxGroup = Checkbox.Group;

type departMent = {
    department_id: string,
    department_name: string,
    children: departMent[],
    childrenShow: boolean,
    dragTargetClass: string
}

type departMentDetail = {
    department_id: string,
    department_name: string,
    is_use_store: number,
    store_id_list: string[]
}

type store = {
    "store_id": string,
    "store_name": string
}

export default function DepartMent() {

    const [form] = useForm()

    const [departmentData, setDepartmentData] = useState<departMent[]>([])
    const [checkedStoreAuths, setCheckedStoreAuths] = useState<string[]>([])
    const [deparmentEditVisible, setDeparmentEditVisible] = useState<boolean>(false)
    const [changeParentVisible, setChangeParentVisible] = useState<boolean>(false)

    const [currentEditRow, setCurrentEditRow] = useState<departMentDetail | undefined>(undefined)
    const [allStore, setAllStore] = useState<store[]>([])
    const [pid, setPid] = useState<string>()
    const [storeCannotEdit, setStoreCannotEdit] = useState<boolean>(false)
    const [dragID, setDragID] = useState<string>()
    const [targetID, setTargetID] = useState<string>()

    const initDepartMentData = (data: departMent[]) => {

        function recursin(data: departMent[]) {
            data.forEach((el: departMent) => {
                el.childrenShow = false
                el.dragTargetClass = ''

                if (el.children && el.children.length > 0) {
                    recursin(el.children)
                }
            })
        }

        if ((data.length > 0 && data[0].children.length > 0)) {
            data[0].children.forEach((el: departMent, index: number) => {
                if (index !== 0) {
                    el.childrenShow = false

                } else {
                    el.childrenShow = true
                    setPid(el.department_id)
                }

                if (el.children && el.children.length > 0) {
                    recursin(el.children)
                }

                el.dragTargetClass = ''
            })

            data[0].childrenShow = true
        }

        return data
    }

    const fetchDepartment = () => {
        baseAxiosNoInfo.get('/manpower_center/department/tree_list').then((response: any) => {
            response && setDepartmentData(initDepartMentData(response))
        })
    }

    const init = () => {
        fetchDepartment()
        setDeparmentEditVisible(false)
    }

    const toggleDisplay = (id: string, isShow?: boolean) => {
        function recursin(data: departMent[]) {
            data.some((el: departMent) => {
                if (el.department_id === id) {
                    el.childrenShow = isShow || !el.childrenShow
                    return data

                } else {
                    if (el.children && el.children.length > 0) {
                        recursin(el.children)
                    }
                }
            })

            return data
        }

        setDepartmentData(recursin(_.cloneDeep(departmentData)))
    }

    const handleDelete = (department_id: string) => {
        function recursin(data: departMent[]) {
            data.some((el: departMent) => {
                if (el.department_id === department_id) {
                    baseAxiosComplete.post('/manpower_center/department/delete', { department_id }).then(res => {
                        res.status === 0 && init()
                    })

                } else if (el.children && el.children.length > 0) {
                    recursin(el.children)
                }
            })

            return data
        }

        recursin(departmentData)
    }

    const handleAdd = (deparementID: string) => {
        setPid(deparementID)
        setCurrentEditRow(undefined)
        setStoreCannotEdit(false)

        form.setFieldsValue({
            department_name: undefined,
            is_use_store: undefined,
            store_id_list: undefined,
        })

        setDeparmentEditVisible(true)
    }

    const handleEdit = (row: departMent) => {
        setDeparmentEditVisible(true)

        baseAxiosNoInfo('/manpower_center/department/detail', { params: { id: row.department_id } }).then((res: any) => {
            if (res) {
                setCurrentEditRow(res)

                form.setFieldsValue({
                    ...res
                })

                if (res.is_use_store === 1) {
                    setStoreCannotEdit(true)
                }
            }
        })
    }

    const deparmentList = (data: departMent[]) => {

        function childRecursin(data2: departMent[], show: boolean) {
            return show ? <ul className="list">
                {data2.map((el: departMent) => <li className={el.dragTargetClass ? "drag-target item" : "item"} data-id={el.department_id} draggable={true} onDragStart={(e) => {
                    setDragID(el.department_id)
                    e.stopPropagation()

                }} onDragEnd={(e) => {
                    if (dragID && targetID) {
                        setChangeParentVisible(true)

                    } else {
                        message.error('必须选中父级组织')
                    }

                    e.stopPropagation()

                }} onDragOver={(e: any) => {
                    let tag = e.target.nodeName.toLowerCase()

                    if (tag === 'li' || tag === 'span' || tag === 'span') {
                        setTargetID(e.target.dataset.id)
                        e.preventDefault()
                        e.stopPropagation()
                    }

                }} >
                    <div className="item-menu" data-id={el.department_id}>
                        {el.childrenShow ? <UpOutlined onClick={() => {
                            toggleDisplay(el.department_id)
                        }} /> : <DownOutlined onClick={() => {
                            toggleDisplay(el.department_id)
                        }} />}

                        <AppstoreOutlined onClick={() => { toggleDisplay(el.department_id) }} />

                        <span data-id={el.department_id} className={el.department_id === pid ? "current title" : "title"} onClick={() => {
                            setPid(el.department_id)
                            toggleDisplay(el.department_id, true)
                        }}>{el.department_name}</span>

                        <FileAddOutlined onClick={() => { handleAdd(el.department_id) }} />
                        <EditOutlined onClick={() => { handleEdit(el) }} />

                        <Popconfirm
                            title="确定删除？"
                            onConfirm={() => {
                                handleDelete(el.department_id)
                            }}
                            okText="确定"
                            cancelText="取消"
                        >
                            <DeleteOutlined />
                        </Popconfirm>
                    </div>

                    {el.children && el.children.length > 0 && childRecursin(el.children, el.childrenShow)}
                </li>)}
            </ul> : null
        }

        return data.map((dm: departMent) => <li className="item" onDragOver={(e: any) => {
            let tag = e.target.nodeName.toLowerCase()

            if (tag === 'li' || tag === 'span' || tag === 'span') {
                setTargetID(e.target.dataset.id)
                e.preventDefault()
                e.stopPropagation()
            }
        }}>
            <div className="item-menu">
                <ApartmentOutlined />
                <span data-id={dm.department_id} className={dm.department_id === pid ? "current title" : "title"} onClick={() => { setPid(dm.department_id); toggleDisplay(dm.department_id, true) }} >{dm.department_name}</span>
                <FileAddOutlined onClick={() => { handleAdd(dm.department_id) }} />
                <EditOutlined onClick={() => { handleEdit(dm) }} />
            </div>

            {dm.children && dm.children.length > 0 && childRecursin(dm.children, dm.childrenShow)}
        </li>)
    }

    const submitEdit = (values: any) => {
        if (currentEditRow) {
            baseAxiosComplete.post('/manpower_center/department/update', {
                ...values,
                department_id: currentEditRow.department_id

            }).then(res => {
                res.status === 0 && init()
                baseAxiosNoInfo('/manpower_center/department/data_permission', { params: { department_id: pid } }).then((res: any) => {
                    if (res) setCheckedStoreAuths(res)
                })
            })

        } else {
            baseAxiosComplete.post('/manpower_center/department/add', {
                ...values,
                p_department_id: pid

            }).then(res => {
                res.status === 0 && init()
            })
        }
    }

    useEffect(() => {
        fetchDepartment()

        baseAxiosNoInfo('/global/store_list').then((res: any) => {
            res && setAllStore(res)
        })
    }, [])

    // 渲染对于门店数据
    useEffect(() => {
        if (pid) {
            baseAxiosNoInfo('/manpower_center/department/data_permission', { params: { department_id: pid } }).then((res: any) => {
                if (res) setCheckedStoreAuths(res)
            })
        }
    }, [pid])

    const storeListValidator = (_: any, value: string[]) => {
        if (!value) return Promise.reject('必须勾选绑定门店权限')

        if (form.getFieldValue('is_use_store') === 1 && value.length > 1) {
            return Promise.reject('是门店组织时，只能勾选一个门店')
        }

        return Promise.resolve()
    }

    return (<div className="common-page">
        {/* 人力中心 -> 组织架构 -> 组织管理 */}
        <BreadCrumb position={['人力中心', '组织管理']} />

        <div className="common-main">
            <Row gutter={30}>
                <Col span={12}>
                    <h3 >组织信息</h3>

                    <div className="new-depeartment-page">
                        <ul className="list">
                            {deparmentList(departmentData)}
                        </ul>
                    </div>
                </Col>

                <Col span={12} className="stote-auth-list">
                    <h3>门店权限</h3>

                    <Checkbox.Group style={{ width: '100%' }} disabled={true} value={checkedStoreAuths} >
                        <Row gutter={8}>
                            {allStore.map(el => <Col>
                                <Checkbox value={el.store_id}>{el.store_name}</Checkbox>
                            </Col>)}
                        </Row>
                    </Checkbox.Group>
                </Col>
            </Row>
        </div>

        <Modal visible={deparmentEditVisible} title={currentEditRow ? "编辑组织" : "新增组织"} footer={false} onCancel={() => { setDeparmentEditVisible(false) }} >
            <Form form={form} onFinish={submitEdit}>
                <Form.Item name="department_name" label="组织名称" rules={[{ required: true, message: '必须填写组织名称' }]}>
                    <Input />
                </Form.Item>

                <Form.Item name="is_use_store" label="是否门店组织" rules={[{ required: true, message: '必须选择是否门店级别组织' }]} >
                    <Radio.Group disabled={storeCannotEdit}>
                        <Radio value={1}>是</Radio>
                        <Radio value={0}>否</Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item name="store_id_list" label="门店数据权限" rules={[{ required: true, validator: storeListValidator }]} >
                    <Checkbox.Group disabled={storeCannotEdit} style={{ width: '100%' }} >
                        <Row gutter={8}>
                            {allStore.map(el => <Col>
                                <Checkbox value={el.store_id}>{el.store_name}</Checkbox>
                            </Col>)}
                        </Row>
                    </Checkbox.Group>
                </Form.Item>

                <p style={{ color: 'red' }}>注意：若是门店组织时，只能选择绑定一个门店数据权限。</p>

                <Form.Item>
                    <Button style={{ width: '100%', marginTop: 10 }} type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>

        <Modal visible={changeParentVisible} onCancel={() => { setChangeParentVisible(false) }} onOk={() => {
            baseAxiosComplete.post('/manpower_center/department/move', {
                department_id: dragID,
                p_department_id: targetID

            }).then((res: any) => {
                setDragID('')
                setTargetID('')

                if (res.status === 0) {
                    init()
                    setChangeParentVisible(false)
                }
            })
        }}>
            确认更改父级组织？
        </Modal>
    </div>)
}